document.addEventListener("option_price_calculator_input_change", () => {
    if (BSS_B2B?.integrateUtils?.getOptionPriceCalculatorPayload) {
        BSS_B2B.pl.utils.product.initPriceList();
        BSS_B2B.observer.productSubject.notifyObserver('ProductMutate', 'ProductPriceMutate');
    }
})

const attackEvents = () => {
    if (window.__st.cid === 25283919610236 && window?.calculatorForm) {
        const inputs = document.querySelectorAll("#calc-form-preview input");
        inputs.forEach(input => {
            input.addEventListener("input", (e) => {
                const customEvent = new CustomEvent("option_price_calculator_input_change");
                document.dispatchEvent(customEvent);
            })
        })
    }
}

const getOptionAppPayload = () => {
    if (window.__st.cid === 25283919610236 && window?.calculatorForm) {
        const { formula, fields } = calculatorForm;
        const inputs = document.querySelectorAll("#calc-form-preview input");
        const payload = { formula: formula };
        inputs.forEach(item => {
            payload[item["name"]] = item.value === "" ? "" : Number(item.value)
        })
        return payload;
    }
}

document.addEventListener("DOMContentLoaded", () => {
    attackEvents();
    if (window?.BSS_B2B?.storeId) {
        BSS_B2B.integrateUtils.getOptionPriceCalculatorPayload = getOptionAppPayload;
    }
});